import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import zhCN from './locales/zh-CN'; // 默认语言文件
import enUS from './locales/en-US';
import viVN from './locales/vi-VN';
import financialZhCN from './locales/zh-CN/financial';
import financialEnUS from './locales/en-US/financial';
import financialViVN from './locales/vi-VN/financial';
import riskControlZhCN from './locales/zh-CN/riskControl';
import riskControlEnUS from './locales/en-US/riskControl';
import riskControlViVN from './locales/vi-VN/riskControl';
import kycZhCN from './locales/zh-CN/kyc';
import kycEnUS from './locales/en-US/kyc';
import kycViVN from './locales/vi-VN/kyc';
import mallZhCN from './locales/zh-CN/mall';
import mallEnUS from './locales/en-US/mall';
import mallViVN from './locales/vi-VN/mall';
import memberZhCN from './locales/zh-CN/member';
import memberEnUS from './locales/en-US/member';
import memberViVN from './locales/vi-VN/member';
import menuZhCN from './locales/zh-CN/menu';
import menuEnUS from './locales/en-US/menu';
import menuViVN from './locales/vi-VN/menu';
import clientZhCN from './locales/zh-CN/client';
import clientEnUS from './locales/en-US/client';
import clientViVN from './locales/vi-VN/client';
import emailZhCN from './locales/zh-CN/email';
import emailEnUS from './locales/en-US/email';
import emailViVN from './locales/vi-VN/email';
// 营销邮件管理 (FBMPLAY-1231) i18n（6 命名空间合并为单文件）
import emailMarketingZhCN from './locales/zh-CN/emailMarketing';
import emailMarketingEnUS from './locales/en-US/emailMarketing';
import emailMarketingViVN from './locales/vi-VN/emailMarketing';
import marketZhCN from './locales/zh-CN/market';
import marketEnUS from './locales/en-US/market';
import marketViVN from './locales/vi-VN/market';
import manualPushZhCN from './locales/zh-CN/manualPush';
import manualPushEnUS from './locales/en-US/manualPush';
import manualPushViVN from './locales/vi-VN/manualPush';
import quotaZhCN from './locales/zh-CN/quota';
import quotaEnUS from './locales/en-US/quota';
import quotaViVN from './locales/vi-VN/quota';
import operationLogZhCN from './locales/zh-CN/operationLog';
import operationLogEnUS from './locales/en-US/operationLog';
import operationLogViVN from './locales/vi-VN/operationLog';
// 西班牙语 (CB7REQ-170)
import esES from './locales/es-ES';
import financialEsES from './locales/es-ES/financial';
import riskControlEsES from './locales/es-ES/riskControl';
import kycEsES from './locales/es-ES/kyc';
import mallEsES from './locales/es-ES/mall';
import memberEsES from './locales/es-ES/member';
import menuEsES from './locales/es-ES/menu';
import clientEsES from './locales/es-ES/client';
import emailEsES from './locales/es-ES/email';
import emailMarketingEsES from './locales/es-ES/emailMarketing';
import marketEsES from './locales/es-ES/market';
import manualPushEsES from './locales/es-ES/manualPush';
import quotaEsES from './locales/es-ES/quota';
import operationLogEsES from './locales/es-ES/operationLog';
import inviteRebateZhCN from './locales/zh-CN/inviteRebate';
import inviteRebateEnUS from './locales/en-US/inviteRebate';
import inviteRebateViVN from './locales/vi-VN/inviteRebate';
import inviteRebateEsES from './locales/es-ES/inviteRebate';

// 合并翻译文件
const zhCNWithModules = {
  ...zhCN,
  financial: financialZhCN,
  ...riskControlZhCN,
  ...kycZhCN,
  ...mallZhCN,
  ...memberZhCN,
  ...menuZhCN,
  ...clientZhCN,
  ...emailZhCN
  , ...emailMarketingZhCN
  , market: marketZhCN
  , ...manualPushZhCN
  , quota: quotaZhCN
  , ...operationLogZhCN
  , ...inviteRebateZhCN
};

const enUSWithModules = {
  ...enUS,
  financial: financialEnUS,
  ...riskControlEnUS,
  ...kycEnUS,
  ...mallEnUS,
  ...memberEnUS,
  ...menuEnUS,
  ...clientEnUS,
  ...emailEnUS
  , ...emailMarketingEnUS
  , market: marketEnUS
  , ...manualPushEnUS
  , quota: quotaEnUS
  , ...operationLogEnUS
  , ...inviteRebateEnUS
};

const viVNWithModules = {
  ...viVN,
  financial: financialViVN,
  ...riskControlViVN,
  ...kycViVN,
  ...mallViVN,
  ...memberViVN,
  ...menuViVN,
  ...clientViVN,
  ...emailViVN
  , ...emailMarketingViVN
  , market: marketViVN
  , ...manualPushViVN
  , quota: quotaViVN
  , ...operationLogViVN
  , ...inviteRebateViVN
};

const esESWithModules = {
  ...esES,
  financial: financialEsES,
  ...riskControlEsES,
  ...kycEsES,
  ...mallEsES,
  ...memberEsES,
  ...menuEsES,
  ...clientEsES,
  ...emailEsES
  , ...emailMarketingEsES
  , market: marketEsES
  , ...manualPushEsES
  , quota: quotaEsES
  , ...operationLogEsES
  , ...inviteRebateEsES
};

// 初始化 i18n 的函数
export const initI18n = (lang: string) => {
  return i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        'zh-CN': {
          translation: zhCNWithModules
        },
        'en-US': {
          translation: enUSWithModules
        },
        'vi-VN': {
          translation: viVNWithModules
        },
        'es-ES': {
          translation: esESWithModules
        }
      },
      lng: lang, // 设置初始语言
      fallbackLng: 'zh-CN',
      debug: process.env.NODE_ENV === 'development',
      interpolation: {
        escapeValue: false
      }
    });
};

// 默认初始化
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'zh-CN': {
        translation: zhCNWithModules
      },
      'en-US': {
        translation: enUSWithModules
      },
      'vi-VN': {
        translation: viVNWithModules
      },
      'es-ES': {
        translation: esESWithModules
      }
    },
    fallbackLng: 'zh-CN',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
